import React from 'react';
import siteBuilder from 'assets/images/site-builder.svg';
import Button from 'common/components/elements/buttons/primary';

const SiteDesignerNotAvailable = () => (
   <div className='flex flex-col items-center justify-center gap-3 min-h-screen px-4 py-6'>
      <img src={ siteBuilder } alt='site-builder' className='w-auto h-[237px] object-contain object-center' />
      <p className='text-xl leading-[24px] font-semibold text-major text-center'>Site builder is only available on desktop devices/view</p>
      <span className='text-secondary text-base font-normal leading-[19.36px] text-center'>Sorry, our site builder is only available on desktop devices or on desktop view on your mobile.</span>
      <div className='h-10 w-15 flex mt-3'>
         <Button
            text='Ok'
            textMarginX='0'
            backgroundColor='transparent'
            textColor='secondary'
            primaryColor={ false }
            textSize='base'
         />
      </div>
   </div>
)

export default SiteDesignerNotAvailable;
